import { get, post} from "../../common/http.services";

export function getProduct(pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/amazon/inventory/virtualproduct?page=${pageNumber}&size=${pageSize}&sort=sku,asc`, appContext, success, error);
}

export function saveProduct(model: any, appContext: any, success: any, error: any) {
    return post(`/amazon/inventory/virtualproduct`, model, appContext, success, error);
}

export function getById(id: any, appContext: any, success: any, error: any) {
    return get(`/amazon/inventory/virtualproduct/findbyid?id=${id}`, appContext, success, error);
}
